import { useQuery, useQueryClient } from "@tanstack/react-query";
import { get, post } from "@/lib/api";

export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: () => get("/auth/me").catch((e) => (e?.response?.status === 401 ? null : Promise.reject(e))),
    staleTime: 30_000,
    retry: false,
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return async () => {
    await post("/auth/logout").catch(() => null);
    qc.clear();
    qc.setQueryData(["me"], null);
  };
}

export const panelPath = (me) => (me?.role === "profesional" ? "/panel" : "/panel");
